/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetChatAnalysisSettingsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetChatAnalysisSettingsRequest = {
  /**
   * Organization whose settings to read.
   */
  organizationId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetChatAnalysisSettingsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetChatAnalysisSettingsSecurity$outboundSchema: z.ZodMiniType<
  GetChatAnalysisSettingsSecurity$Outbound,
  GetChatAnalysisSettingsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getChatAnalysisSettingsSecurityToJSON(
  getChatAnalysisSettingsSecurity: GetChatAnalysisSettingsSecurity,
): string {
  return JSON.stringify(
    GetChatAnalysisSettingsSecurity$outboundSchema.parse(
      getChatAnalysisSettingsSecurity,
    ),
  );
}

/** @internal */
export type GetChatAnalysisSettingsRequest$Outbound = {
  organization_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetChatAnalysisSettingsRequest$outboundSchema: z.ZodMiniType<
  GetChatAnalysisSettingsRequest$Outbound,
  GetChatAnalysisSettingsRequest
> = z.pipe(
  z.object({
    organizationId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function getChatAnalysisSettingsRequestToJSON(
  getChatAnalysisSettingsRequest: GetChatAnalysisSettingsRequest,
): string {
  return JSON.stringify(
    GetChatAnalysisSettingsRequest$outboundSchema.parse(
      getChatAnalysisSettingsRequest,
    ),
  );
}
